function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".goal-svg-non-color-part{fill:none;}.goal-svg-color-part{fill:#686868;}"));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "goal-svg-non-color-part",
  width: 24,
  height: 24
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "goal-svg-color-part",
  d: "M16,2H14V1a1,1,0,0,0-1-1H5A1,1,0,0,0,4,1V2H2A2.006,2.006,0,0,0,0,4V5A4.991,4.991,0,0,0,4.39,9.94,5.009,5.009,0,0,0,8,12.9V16H5a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2H10V12.9a5.009,5.009,0,0,0,3.61-2.96A4.991,4.991,0,0,0,18,5V4A2.006,2.006,0,0,0,16,2ZM4,7.82A3.01,3.01,0,0,1,2,5V4H4ZM12,8A3,3,0,0,1,6,8V2h6Zm4-3a3.01,3.01,0,0,1-2,2.82V4h2Z",
  transform: "translate(3 3)"
});

function SvgGoal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal);
export default __webpack_public_path__ + "static/media/goal.f4ac0527.svg";
export { ForwardRef as ReactComponent };